// Unused Dealers
export const GET_UNUSED_DEALERS='GET_UNUSED_DEALERS';
export const GET_UNUSED_DEALERS_SUCCESSFUL='GET_UNUSED_DEALERS_SUCCESSFUL';
export const GET_UNUSED_DEALERS_FAILED='GET_UNUSED_DEALERS_FAILED';